import React, { useState, useCallback } from "react";
import RadioButton from "../RadioButton";
import styles from "./RadioDropdown.module.scss";

interface DropdownOption {
  value: string;
  name: string;
}

interface CustomDropdownProps {
  label?: string;
  value: string;
  options: DropdownOption[];
  onSelect: (val: DropdownOption) => void;
}

const CustomRadioDropdown = ({
  label = "",
  value,
  options,
  onSelect,
}:CustomDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOptionClick = (option: DropdownOption) => {
    if (option.name !== "Other") {
      onSelect(option);
      setIsOpen(false);
    } else {
      onSelect({ name: option.name, value: "Other: " });
    }
  };

  const handleOtherInput = (name: string, value: string) => {
    onSelect({ name, value: name + ": " + value });
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const checkIfActive = (name: string, val: string) => {
    if (name === "Other" && value?.includes("Other: ")) return true;
    return value === val;
  };

  return (
    <div className={styles.customDropdown}>
      <div className={styles.label}>{label}</div>
      <div className={styles.dropdownHeader} onClick={toggleDropdown}>
        {value ? value : "Select Option"}
        <div className={isOpen ? styles.arrowUp : styles.arrowDown}></div>
      </div>
      {isOpen && (
        <div className={styles.dropdownList}>
          {options?.map(({ name, value: val }, i) => (
            <div
              key={`options-${i}`}
              onClick={() => handleOptionClick({ name, value: val })}
            >
              <RadioButton
                id={val}
                checked={checkIfActive(name, val)}
                value={val}
                label={name}
                className={styles.item}
                onChange={() => null}
                textVal={value?.split("Other: ")?.[1]}
                onTextInputChange={
                  name === "Other"
                    ? (val) => handleOtherInput(name, val)
                    : undefined
                }
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomRadioDropdown;
